{
  "create_new_schedule": "Créez un nouveau calendrier",
  "copy_schedule_alert": "La copie des données du calendrier peut prendre quelques minutes",
  "manage_schedule_settings": "Gérer les paramètres de planification",
  "all_venues": "Toutes les salles",
  "no_venues": "Aucune salle",
  "x_venues_selected": "{{ count }} lieux sélectionnés",
  "view_by": "Afficher par",
  "day": "Journée",
  "venue": "Lieu",
  "cluster": "Cluster",
  "no_space_defined": "Aucun espace défini",
  "no_sessions_in_view": "Aucune session dans cette vue",
  "discipline": "La discipline",
  "day_discipline": "Journée (Discipline)",
  "day_venue": "Jour (Lieu)",
  "daily_run_sheet": "Feuille de course quotidienne",
  "venue_run_sheet": "Feuille de gestion des sites",
  "DCAS": "DCAS",
  "summary": "Résumé",
  "show_scheduled_items": "Afficher les éléments planifiés",
  "hide_scheduled_items": "Masquer les éléments planifiés",
  "show_sessions": "Afficher les sessions",
  "hide_sessions": "Masquer les sessions",
  "error_loading_schedule": "Une erreur s'est produite lors du chargement du calendrier",
  "schedule": "Calendrier",
  "save_schedule": "enregistrer le calendrier",
  "delete_schedule": "supprimer le calendrier",
  "create_schedule_form": {
    "create_new_schedule": "Créez un nouveau calendrier",
    "name_field_label": "Nom du nouvel horaire",
    "status_field_label": "Définir le statut du nouveau calendrier",
    "status_field_options": {
      "draft_label": "Brouillon",
      "draft_description": "Calendrier visible uniquement pour les personnes nommées dans les paramètres d'autorisation",
      "published_label": "Publié",
      "published_description": "Visible pour tous"
    },
    "copy_versions_label": "Sélectionnez les calendriers de discipline que vous souhaitez copier dans ce nouveau calendrier"
  },
  "create_sub_schedule_form": {
    "create_new_sub_schedule": "Créer un nouveau calendrier {{ subSchedule }}",
    "parent_schedule": "Horaire pour les parents",
    "new": "Nouveau",
    "copy_existing": "Copie de l'existant",
    "name_of_calendar": "Nom du calendrier",
    "selectSubSchedulesToCopy": "Sélectionnez le {{ scheduleVersionType }} (s) que vous souhaitez copier"
  },
  "edit_schedule_form": {
    "edit_schedule": "Gérer les paramètres de planification",
    "name_field_label": "Nom de l'horaire",
    "status_field_label": "Définir l'état du calendrier"
  },
  "edit_schedule_data_options": {
    "title": "Modifier les options de données de planification"
  },
  "add_data_fields_form": {
    "add_datafield_list_items": "Ajouter des éléments de liste d'attributs",
    "download_template": "Télécharger le modèle CSV",
    "upload": "Charger un fichier CSV",
    "venue_location": "Emplacement du lieu"
  },
  "settings": "paramètres",
  "visibility": "visibilité",
  "create_session_form": {
    "create_new_session": "Créer une nouvelle session",
    "ticketedDescription": "Session marquée comme étant associée à un ticket par défaut",
    "headings": {
      "formTitleNew": "Nouvelle session",
      "formTitleEdit": "Modifier la session",
      "details": "Détails",
      "time": "Horaires des sessions",
      "venue": "Lieu",
      "events": "Événements de cette session",
      "type": "Style de session",
      "entry": "Entrée et diffusion",
      "ticketingAndBroadcasting": "Billetterie et diffusion",
      "ticketed": "Billetté"
    },
    "inputLabels": {
      "code": "Code de session",
      "style": "Style de session",
      "description": "Description de la session (facultatif)",
      "day": "Journée",
      "spare": "À utiliser comme journée libre",
      "sTime": "Heure de début",
      "eTime": "Heure de fin",
      "zTime": "Heure zéro",
      "zeroCheckBoxLabel": "Identique à l'heure de début de la session",
      "estimated": "Fin estimée",
      "duration": "Durée (minutes)",
      "ticketed": "Séance payante"
    },
    "buttons": {
      "addEvent": "Ajouter un événement",
      "addAnother": "Ajouter un autre événement",
      "removeEvent": "Supprimer l'événement",
      "addPhase": "Ajouter une phase",
      "addAnotherPhase": "Ajouter une autre phase",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "delete_session": "Supprimer la session"
    },
    "delete": {
      "title": "Supprimer la session",
      "message": "La suppression de cette session supprimera également ses éléments programmés et toutes les activités qui y sont spécifiquement liées. Souhaitez-vous continuer ?",
      "confirm": "Confirmer",
      "cancel": "Annuler"
    }
  },
  "summary_grid": {
    "venue": "Lieu",
    "discipline": "La discipline"
  },
  "scheduled_item": {
    "CREATE": "Nouvel article programmé",
    "EDIT": "Modifier l'élément planifié",
    "within_event": "Au cours de l'événement",
    "delete_item": "Supprimer l'article",
    "venue": "Lieu",
    "space": "L'espace",
    "time": "Heure",
    "location": "Lieu",
    "delete": {
      "title": "Supprimer un élément programmé",
      "message": "Tu es sûr ?",
      "confirm": "Confirmer",
      "cancel": "Annuler"
    },
    "time_type": {
      "not_before": {
        "name": "Pas avant",
        "description": "L'article programmé ne débutera pas avant l'heure de début indiquée."
      },
      "followed_by": {
        "name": "Suivi par",
        "description": "L'heure de début dépend de l'heure de fin de l'élément planifié précédent."
      }
    },
    "estimated_duration": "Durée estimée",
    "estimated_duration_description": "La durée exacte de l'item programmé n'est pas certaine.",
    "save_and_next": "Enregistrer et suivre",
    "save_and_finish": "Enregistrer et terminer"
  },
  "session_card": {
    "day": "Journée",
    "start_time": "Heure de début",
    "end_time": "Heure de fin",
    "duration": "Durée",
    "medal_session": "Session de médailles",
    "add_scheduled_item": "Ajouter un élément programmé",
    "scheduled_items_in_session": "Points programmés pendant la session",
    "events_in_session": "Événements en cours de session",
    "close_popup": "Fermer la fenêtre contextuelle",
    "edit": "Modifier",
    "zero_time": "Heure zéro",
    "no_space": "Pas d'espace",
    "in": "Dans",
    "show_more": "Afficher plus",
    "show_less": "Afficher moins"
  }
}